import { Filter } from 'lucide-react'
import { useTranslation } from '../../core/hooks/useTranslation'

interface FilterButtonProps {
    onClick: () => void
    className?: string
    title?: string
}

export default function FilterButton({
    onClick,
    className = '',
    title
}: FilterButtonProps) {
    const { t } = useTranslation()
    const displayTitle = title || t('filter')

    return (
        <button
            onClick={onClick}
            className={`border border-gray-300 text-[#1E293B] hover:text-[#1E293B] hover:border-[#1E293B] hover:bg-gray-50 active:bg-gray-100 flex items-center justify-center py-3 px-3 rounded-xl transition-colors ${className}`}
            title={displayTitle}
        >
            <Filter className="w-5 h-5" />
        </button>
    )
}

